import { createAction, createActionGroup, props } from '@ngrx/store';
import { DisclosedDocumentDto } from '@shared/models/disclosed-document-dto';
import { Pageable } from '@shared/models/page-sort/pageable';
import { DocumentDetailsDto } from '@shared/models/document-details-dto';

export const loadDisclosedDocuments = createAction(
    '[Home Component] Load disclosed documents',
    props<{ searchType: string, pageable: Pageable }>()
);

export const disclosedDocumentApiActions = createActionGroup({
    source: 'Disclosed Document API',
    events: {
        disclosedDocumentsLoadedSuccess: props<{ disclosedDocuments: DisclosedDocumentDto[] }>()
    }
});

export const downloadDisclosedDocument = createAction(
    '[Home Component] Download disclosed document',
    props<{ attachment: DocumentDetailsDto, disclosedDocument: DisclosedDocumentDto }>()
);

export const downloadDisclosedDocumentsAsZip = createAction(
    '[Home Component] Download disclosed documents as zip',
    props<{ attachments: DocumentDetailsDto[], disclosedDocument: DisclosedDocumentDto }>()
);
